import { NgModule } from '@angular/core';
import { SplitPipe } from './split.pipe';
import { DefaultStringPipe } from './default-string.pipe';
import { DefaultNumberPipe } from './default-number.pipe';
import { TzdatePipe } from './tzdate.pipe';
import { OrdinalPipe } from './ordinal.pipe';
import { DecimalFormatPipe } from './decimal-format.pipe';
import { SafeHtmlPipe } from './safeHtml.pipe';
import { SecondsToMinutesPipe } from './seconds-to-minutes.pipe';
import { EmailMaskPipe } from './email-mask.pipe';
import { FormatDateTimePipe } from './format-date-time.pipe';
import { DateFormatPipe } from './date-format.pipe';
import { DateAndTimeShowPipe } from './date-and-time-show.pipe';

@NgModule({
  declarations: [
    SplitPipe,
    DefaultStringPipe,
    DefaultNumberPipe,
    TzdatePipe,
    OrdinalPipe,
    DecimalFormatPipe,
    SafeHtmlPipe,
    SecondsToMinutesPipe,
    EmailMaskPipe,
    FormatDateTimePipe,
    DateAndTimeShowPipe,
    DateFormatPipe,
    DateAndTimeShowPipe,
  ],
  exports: [
    SplitPipe,
    DefaultStringPipe,
    DefaultNumberPipe,
    TzdatePipe,
    OrdinalPipe,
    DecimalFormatPipe,
    SafeHtmlPipe,
    SecondsToMinutesPipe,
    EmailMaskPipe,
    FormatDateTimePipe,
    DateAndTimeShowPipe,
  ],
})
export class CustomPipesModule {}
